import { expose } from 'threads/worker';
import { getFromMapOrThrow } from '../../util';
export function wrappedRxStorage(args) {
    let nextId = 0;
    const instanceById = new Map();
    const exposeMe = {
        /**
         * RxStorageInstance
         */
        async createStorageInstance(params) {
            const instanceId = nextId++;
            const instance = await args.storage.createStorageInstance(params);
            instanceById.set(instanceId, instance);
            return instanceId;
        },
        bulkWrite(instanceId, documentWrites) {
            const instance = getFromMapOrThrow(instanceById, instanceId);
            return instance.bulkWrite(documentWrites);
        },
        bulkAddRevisions(instanceId, documents) {
            const instance = getFromMapOrThrow(instanceById, instanceId);
            return instance.bulkAddRevisions(documents);
        },
        findDocumentsById(instanceId, ids, deleted) {
            const instance = getFromMapOrThrow(instanceById, instanceId);
            return instance.findDocumentsById(ids, deleted);
        },
        query(instanceId, preparedQuery) {
            const instance = getFromMapOrThrow(instanceById, instanceId);
            return instance.query(preparedQuery);
        },
        getAttachmentData(instanceId, documentId, attachmentId) {
            const instance = getFromMapOrThrow(instanceById, instanceId);
            return instance.getAttachmentData(documentId, attachmentId);
        },
        getChangedDocuments(instanceId, options) {
            const instance = getFromMapOrThrow(instanceById, instanceId);
            return instance.getChangedDocuments(options);
        },
        changeStream(instanceId) {
            const instance = getFromMapOrThrow(instanceById, instanceId);
            return instance.changeStream();
        },
        close(instanceId) {
            const instance = getFromMapOrThrow(instanceById, instanceId);
            return instance.close();
        },
        remove(instanceId) {
            const instance = getFromMapOrThrow(instanceById, instanceId);
            return instance.remove();
        },
        /**
         * RxKeyObjectStorageInstance
         */
        async createKeyObjectStorageInstance(params) {
            const instanceId = nextId++;
            const instance = await args.storage.createKeyObjectStorageInstance(params);
            instanceById.set(instanceId, instance);
            return instanceId;
        },
        bulkWriteLocal(instanceId, documentWrites) {
            const instance = getFromMapOrThrow(instanceById, instanceId);
            return instance.bulkWrite(documentWrites);
        },
        findLocalDocumentsById(instanceId, ids) {
            const instance = getFromMapOrThrow(instanceById, instanceId);
            return instance.findLocalDocumentsById(ids);
        }
    };
    expose(exposeMe);
}
